/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'security-level-help',
  templateUrl: './security-level-help.component.html',
  styleUrls: ['./security-level-help.component.less'],
  standalone: false,
})
export class SecurityLevelHelpComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
